import { observer } from 'mobx-react';
import { FC } from 'react';
import SmsPlatformControls from '../../components/SmsPlatformControls/SmsPlatformControls';
import takerConnectStore from '../../store/takerConnectStore';
import { ConnectionService } from '../../types/takerConnect';
import { TBooleanInNumber } from '~/types/main';
import Text from '~/view/components/Text/Text';
import Input from '~/view/components/Controls/InputComponent/Input';
import { localeStore } from '~/mobx/localesStore';
import './style.scss';

const Unifonic: FC = observer((): JSX.Element => {
  const { status, priority, apiKey, apiUrl, senderName } = takerConnectStore.services.get(ConnectionService.Unifonic) || {
    status: 1,
    priority: '',
    apiKey: '',
    apiUrl: '',
    senderName: '',
  };

  const handleStatusChange = (status: TBooleanInNumber) => {
    takerConnectStore.changeServiceData(ConnectionService.Unifonic, { status });
  };

  const handlePriorityChange = (value: string | undefined) => {
    takerConnectStore.changeServiceData(ConnectionService.Unifonic, { priority: value });
  };

  const handleSmsKeyChange = (value: string | undefined) => {
    takerConnectStore.changeServiceData(ConnectionService.Unifonic, { apiKey: value });
  };

  const handleSenderNameChange = (value: string | undefined) => {
    takerConnectStore.changeServiceData(ConnectionService.Unifonic, { senderName: value });
  };

  const handleApiUrlChange = (value: string | undefined) => {
    takerConnectStore.changeServiceData(ConnectionService.Unifonic, { apiUrl: value });
  };

  return (
    <div className="d-flex flex-column gap-25">
      <SmsPlatformControls
        type={ConnectionService.Unifonic}
        status={status}
        smsKey={apiKey}
        priority={priority}
        onStatusChange={handleStatusChange}
        onPriorityChange={handlePriorityChange}
        onSmsKeyChange={handleSmsKeyChange}
      />

      {status ? (
        <>
          <div className="unifonic__element hidden">
            <Text type="block-header" text="sender" />
            <Input value={senderName} onChangeValue={handleSenderNameChange} placeholder={localeStore.t('Value')} contentClassName="full-width" />
          </div>

          <div className="unifonic__element hidden">
            <Text type="block-header" text="connect_api_url" />
            <Input value={apiUrl} onChangeValue={handleApiUrlChange} placeholder={localeStore.t('Value')} contentClassName="full-width" />
          </div>
        </>
      ) : null}
    </div>
  );
});
export default Unifonic;
